"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLockStatus = void 0;
/* eslint-disable import/prefer-default-export */
var parseLockStatus = function (dataView) {
    try {
        if (dataView.byteLength === 4) {
            return {
                locked: !!(dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(0)),
                lockMode: dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(1),
                bleTimeout: dataView === null || dataView === void 0 ? void 0 : dataView.getUint16(2),
            };
        }
        else {
            return {
                locked: !!(dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(0)),
                outOfRange: !!(dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(1)),
            };
        }
    }
    catch (_a) {
        return {
            locked: !!(dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(0)),
        };
    }
};
exports.parseLockStatus = parseLockStatus;
